import { c as _c } from "react/compiler-runtime";
/**
 * useUserProfilePrefetchIntent — canonical hover/focus/touch intent triple
 * for any element that navigates to a user's portfolio page (e.g.
 * `/portfolio/[userId]`).
 *
 * Wraps `usePrefetchGetUser` + `useIntentPrefetch` with the canonical
 * `PORTFOLIO_USER_PROFILE_FIELDS` projection — keeping the cache-key
 * fingerprint aligned with the destination page's `useGetUser` call so the
 * prefetch entry actually hits on first paint.
 *
 * No-ops when `userId` is null or empty — safe to spread on rows where the
 * user reference is optional (e.g. anonymous boosters).
 *
 * Usage (inside a DataTable.Row, NavLink, or any element accepting
 * `intent: IntentHandlers`):
 *
 *     const intent = useUserProfilePrefetchIntent(entry.user.userId);
 *     return <DataTable.Row intent={intent} onClick={navigate}>...</DataTable.Row>;
 */

import { type IntentHandlers, useIntentPrefetch, usePrefetchGetUser } from '@morfi/backend-sdk-v2/client';
import { PORTFOLIO_USER_PROFILE_FIELDS } from '@/lib/sdk/projections';
export function useUserProfilePrefetchIntent(userId) {
  const $ = _c(3);
  const prefetchUser = usePrefetchGetUser();
  let t0;
  if ($[0] !== prefetchUser || $[1] !== userId) {
    t0 = () => {
      if (userId === null || userId.length === 0) {
        return;
      }
      prefetchUser({
        identifier: userId,
        fields: [...PORTFOLIO_USER_PROFILE_FIELDS]
      });
    };
    $[0] = prefetchUser;
    $[1] = userId;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return useIntentPrefetch(t0);
}